import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=638e1961"
import script from "./BlankLayout.vue?vue&type=script&lang=js"
export * from "./BlankLayout.vue?vue&type=script&lang=js"
import style0 from "./BlankLayout.vue?vue&type=style&index=0&id=638e1961&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports